import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import {
  KreFormFieldConfig,
  KreTableFieldConfig,
  KreFormInfo,
  clone,
  KreTableConfig,
  KreFormCommonService,
} from "@kre-form/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import * as _ from "lodash";
import { KreFormAntService } from "../../tools/service";
import {
  FormLayout,
  LayoutPanel,
  LayoutColumn,
  KreTableBusiness,
  ICheckedField,
  IBusinessTable,
  Itable,
  IDesignFormAPI,
} from "../../tools/util";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { KreDialogService } from "../../service/dialog.service";
import { DataService } from "../../service/data.service";
import { KreAntCommonService } from "../../tools/commonService";
import { KreTransferService } from "../../tools/transferService";
import { KreDesginToFormService } from "../../tools/tableFieldService";
import { KreFormDSField } from "../field/index.component";
import { KreFormDSFieldLabel } from "../field-label/index.component";
import { KreFormDesignTable } from "../table/table.component";
import { KreFormDesignTables } from "../tables/table.component";
import { group } from "@angular/animations";
import { filter } from "rxjs/operators";

@Component({
  selector: "kreform-design",
  templateUrl: "./detail.component.html",
  styleUrls: ["./detail.component.less"],
  providers: [DataService, KreAntCommonService, KreTransferService],
})
export class KreFormDesignDetail implements OnInit, OnChanges, OnDestroy {
  @Input() formCode: string = "";
  @Input() layout = true;
  @Input() api: IDesignFormAPI = {
    tables: { url: "assets/mockData/business.json" },
    form: { url: "assets/mockData/formInfo.json" },
  };
  @Output() saveEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() cancelEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() previewEvent: EventEmitter<string> = new EventEmitter<string>();

  pageStatus: number = 1;

  form_model: any = {};
  form_group = new FormGroup({});
  form_fields: KreFormFieldConfig[] = [];

  kreFormInfo: KreFormInfo = {};

  business_tables: IBusinessTable = {
    primary: {},
    child: { single: [], multiple: [] },
  };

  layout_column: string = "layout-column-3";
  layout_row: string = "layout-row-1";

  table_Data: Itable[] = [];

  constructor(
    private message: NzMessageService,
    private modalService: NzModalService,
    private kreFormAntService: KreFormAntService,
    public kreDialogService: KreDialogService,
    public dataService: DataService,
    public kreAntCommonService: KreAntCommonService,
    public kreTransferService: KreTransferService,
    public kreDesginToFormService: KreDesginToFormService,
    public kreFormCommonService: KreFormCommonService
  ) {}

  ngOnInit() {
    this.kreFormAntService.btnEvent.subscribe((res: any) => {
      switch (res["type"]) {
        case "delete":
          this.modalService.confirm({
            nzTitle: "提示",
            nzContent: "您确定要删除选中的字段？",
            nzOnOk: () => {
              this.groupBtnDeleteFields(res["field"]);
            },
          });
          break;
        case "up":
        case "down":
          this.groupBtnMoveUpOrDown(res["field"], res["type"]);
          break;
        case "item":
          this.groupBtnTableFields(res["field"]);
          break;
        case "remark":
        case "line":
          this.groupBtnAddLineRemark(res["field"], res["type"]);
          break;
        default:
          break;
      }
    });

    this.kreFormAntService.fieldEvent.subscribe((res: any) => {
      let sign = res["sign"];
      if (sign == "edit") {
        this.editFormFieldConfig(res["field"]);
      } else if (sign == "delete") {
        this.modalService.confirm({
          nzTitle: "提示",
          nzContent: "您确定要删除该字段？",
          nzOnOk: () => {
            this.deleteFormFieldConfig(res["field"]);
          },
        });
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formCode) {
      this.initTablesInfo();
    }
  }

  ngOnDestroy() {}

  /*按钮区域---begin*/

  btnSave() {
    this.kreFormInfo.fields = clone(this.form_fields);
    if (
      this.kreFormInfo.fields !== null &&
      this.kreFormInfo.fields !== undefined
    ) {
      this.kreFormCommonService.initFormFieldProperty(this.kreFormInfo.fields);
    }
    this.saveEvent.emit(JSON.stringify(this.kreFormInfo));
  }

  btnCancel() {}

  btnPreview() {
    this.kreFormInfo.fields = clone(this.form_fields);
    if (
      this.kreFormInfo.fields !== null &&
      this.kreFormInfo.fields !== undefined
    ) {
      this.kreFormCommonService.initFormFieldProperty(this.kreFormInfo.fields);
    }
    this.previewEvent.emit(JSON.stringify(this.kreFormInfo));
  }

  btnDelete() {
    this.modalService.confirm({
      nzTitle: "提示",
      nzContent: "您确定要删除选中的字段？",
      nzOnOk: () => {
        this.getCheckFields().forEach((item: any) => {
          this.form_fields.forEach((field, index, object) => {
            if (
              field.key === item.field.key &&
              _.get(field, "templateOptions.isButintin") != true
            ) {
              object.splice(index, 1);
            }
          });
        });

        this.initTableFieldStatus();
      },
    });
  }

  btnMoveUp() {
    this.getCheckFields().forEach((item: any) => {
      if (item.index > 0) {
        this.form_fields.splice(item.index, 1);
        this.form_fields.splice(item.index - 1, 0, item.field);
      }
    });
  }

  btnMoveDown() {
    this.getCheckFields()
      .reverse()
      .forEach((item) => {
        if (item.index < this.form_fields.length - 1) {
          this.form_fields.splice(item.index, 1);
          this.form_fields.splice(item.index + 1, 0, item.field);
        }
      });
  }

  btnAddFields() {
    this.selectTableFields();
  }

  btnAddRemark() {
    this.kreTransferService.transferLabelToForm(
      this.form_fields,
      this.getCheckFields()
    );
  }

  btnAddLine() {
    this.kreTransferService.transferLineToForm(
      this.form_fields,
      this.getCheckFields()
    );
  }

  btnAddGroup() {
    let tablecode = this.getTableMultipleCode();
    if (tablecode == null || tablecode == "") {
      this.message.warning(
        "当前业务表没有相关联的多表单记录，故不能添加多记录区域！"
      );
      return;
    }
    if (
      this.business_tables &&
      this.business_tables.child &&
      this.business_tables.child.multiple &&
      this.business_tables.child.multiple.length > 0
    ) {
      if (
        this.business_tables.child.multiple.some((item: any) => {
          return item.tableQuote !== true;
        })
      ) {
        this.kreDialogService.CreateModelDialog(
          {
            nzTitle: "编辑",
            size: "large",
            nzContent: KreFormDesignTables,
          },
          { businessTable: this.business_tables, tableType: "single" },
          (instance: any, modal: any) => {
            modal.destroy();
            this.kreTransferService.transferGroupToForm(
              this.form_fields,
              this.getCheckFields(),
              instance.radioValue
            );

            this.initTableFieldStatus();
          }
        );
      }
    }
  }

  btnColumn(type: number) {
    this.kreFormInfo.column = `layout-column-${type}`;
    this.layout_column = this.kreFormInfo.column;
  }

  btnRow(type: number) {
    this.kreFormInfo.row = `layout-row-${type}`;
    this.layout_row = this.kreFormInfo.row;
  }

  getCheckFields() {
    let checkedField: ICheckedField[] = [];
    this.form_fields.forEach((item, index) => {
      if (item.checked) {
        checkedField.push({ index: index, field: item });
      }
    });
    return checkedField;
  }

  /*按钮区域---end*/

  groupBtnMoveUpOrDown(groupField: KreFormFieldConfig, type: string) {
    if (
      !_.get(groupField, "fieldArray.fieldGroup") ||
      _.get(groupField, "fieldArray.fieldGroup").length < 1
    ) {
      groupField.fieldArray = {
        fieldGroup: [],
      };
    }
    let res = this.kreTransferService.groupFieldMoveUpOrDown(
      this.form_fields,
      groupField,
      type
    );
    if (res != null) {
      this.form_fields = res;
      if (groupField.key !== null && groupField.key !== undefined) {
        this.form_model[groupField.key] = [{}];
      }
    }
  }

  groupBtnAddLineRemark(groupField: KreFormFieldConfig, type: string) {
    if (
      !_.get(groupField, "fieldArray.fieldGroup") ||
      _.get(groupField, "fieldArray.fieldGroup").length < 1
    ) {
      groupField.fieldArray = {
        fieldGroup: [],
      };
    }
    let res = null;
    if (type === "line") {
      res = this.kreTransferService.groupTransferLineToForm(
        this.form_fields,
        groupField
      );
    } else if (type === "remark") {
      res = this.kreTransferService.groupTransferRemarkToForm(
        this.form_fields,
        groupField
      );
    }
    if (res != null) {
      this.form_fields = res;
      if (groupField.key !== null && groupField.key !== undefined) {
        this.form_model[groupField.key] = [{}];
      }
    }
  }

  groupBtnTableFields(groupField: KreFormFieldConfig) {
    this.kreDialogService.CreateModelDialog(
      {
        nzTitle: "编辑",
        size: "large",
        nzContent: KreFormDesignTable,
      },
      {
        businessTable: this.business_tables,
        tableType: "multiple",
        fieldConfig: groupField,
      },
      (instance: any, modal: any) => {
        modal.destroy();
        let res = this.kreTransferService.groupTransferSelectFieldToForm(
          this.form_fields,
          groupField,
          this.getCheckFields(),
          this.business_tables,
          instance.mapOfCheckedId
        );
        if (res != null) {
          this.form_fields = res;
          if (groupField.key !== null && groupField.key !== undefined) {
            this.form_model[groupField.key] = [{}];
          }
        }

        this.initTableFieldStatus();
      }
    );
  }

  groupBtnDeleteFields(groupField: KreFormFieldConfig) {
    if (
      !_.get(groupField, "fieldArray.fieldGroup") ||
      _.get(groupField, "fieldArray.fieldGroup").length < 1
    ) {
      return;
    }
    let res = this.kreTransferService.groupTransferDeleteForm(
      this.form_fields,
      groupField
    );
    if (res != null) {
      this.form_fields = res;
      if (groupField.key !== null && groupField.key !== undefined) {
        this.form_model[groupField.key] = [{}];
      }
    }
    this.initTableFieldStatus();
  }

  initTablesInfo() {
    this.business_tables;
    this.dataService
      .getBusinessTables(this.api.tables.url, { formcode: this.formCode })
      .subscribe((res) => {
        if (res != null) {
          this.business_tables = res;
          this.initFormInfo();
        }
      });
  }

  initFormInfo() {
    this.dataService
      .getFormInfo(this.api.form.url, { formcode: this.formCode })
      .subscribe((res) => {
        this.kreFormInfo = {
          code: res.code,
          name: res.name,
          type: res.type,
          fields: res.fields,
        };
        if (
          this.kreFormInfo.fields !== null &&
          this.kreFormInfo.fields !== undefined
        ) {
          this.kreFormCommonService.initFormFieldModel(
            this.kreFormInfo.fields,
            this.form_model
          );

          this.form_fields = this.kreFormInfo.fields;
        }
        if (res.column != undefined && res.column != null && res.column != "") {
          this.kreFormInfo.column = res.column;
        } else {
          this.kreFormInfo.column = "layout-column-3";
        }
        if (res.row != undefined && res.row != null && res.row != "") {
          this.kreFormInfo.row = res.row;
        } else {
          this.kreFormInfo.row = "layout-row-1";
        }
        if (
          this.kreFormInfo.column != undefined &&
          this.kreFormInfo.column != null &&
          this.kreFormInfo.row != undefined &&
          this.kreFormInfo.row != null
        ) {
          this.layout_column = this.kreFormInfo.column;
          this.layout_row = this.kreFormInfo.row;
          this.kreDesginToFormService.initFormFieldByTables(
            this.business_tables,
            this.form_fields
          );
          this.initTableFieldStatus();
        }
      });
  }

  initTableFieldStatus() {
    this.kreDesginToFormService.initTableStatus(
      this.business_tables,
      this.form_fields
    );
    this.initTablesData();
  }

  initTablesData() {
    this.table_Data = [];
    let business = clone(this.business_tables);
    let tables: any = [];
    if (!business) return;

    if (business.primary && business.primary != null) {
      tables = [
        {
          tableType: "primary",
          tableLabel: "主表",
          tableCode: business.primary["tableCode"],
          tableName: business.primary["tableName"],
          tableFields: business.primary["tableFields"],
        },
      ];
    }
    if (
      business.child &&
      business.child != null &&
      business.child.single &&
      business.child.single != null &&
      business.child.single.length > 0
    ) {
      if (Array.isArray(business.child.single)) {
        business.child.single.forEach((item: any) => {
          tables.push({
            tableType: "single",
            tableLabel: "单记录子表",
            tableCode: item["tableCode"],
            tableName: item["tableName"],
            tableFields: item["tableFields"],
          });
        });
      }
    }
    if (
      business.child &&
      business.child != null &&
      business.child.multiple &&
      business.child.multiple != null &&
      business.child.multiple.length > 0
    ) {
      if (Array.isArray(business.child.multiple)) {
        business.child.multiple.forEach((item: any) => {
          tables.push({
            tableType: "multiple",
            tablelabel: "多记录子表",
            tableCode: item["tableCode"],
            tableName: item["tableName"],
            tableFields: item["tableFields"],
          });
        });
      }
    }
    this.table_Data = tables;
  }

  //表单选择
  selectTableFields() {
    this.kreDialogService.CreateModelDialog(
      {
        nzTitle: "编辑",
        size: "large",
        nzContent: KreFormDesignTable,
      },
      { businessTable: this.business_tables, tableType: "single" },
      (instance: any, modal: any) => {
        modal.destroy();
        this.kreTransferService.transferSelectFieldToForm(
          this.form_fields,
          this.getCheckFields(),
          this.business_tables,
          instance.mapOfCheckedId
        );
        this.initTableFieldStatus();
      }
    );
  }

  getTableMultipleCode() {
    let resTableCode = "";
    if (
      this.business_tables &&
      this.business_tables.child &&
      this.business_tables.child.multiple &&
      this.business_tables.child.multiple.length > 0
    ) {
      this.business_tables.child.multiple.forEach((item: any) => {
        if (item.tablequote !== true && resTableCode == "") {
          resTableCode = item.tablecode;
        }
      });
    }
    return resTableCode;
  }

  //修改Field
  editFormFieldConfig(field: KreFormFieldConfig) {
    let content: any;
    let title = "";
    if (field.type === "html") {
      title = "编辑片段文本描述";
      content = KreFormDSFieldLabel;
    } else {
      title = "编辑字段 - " + _.get(field, "templateOptions.label");
      content = KreFormDSField;
    }
    this.kreDialogService.CreateModelDialog(
      {
        nzTitle: title,
        size: "large",
        nzContent: content,
      },
      { field: clone(field) },
      (instance: any, modal: any) => {
        if (instance.checkSave()) {
          let result = this.kreTransferService.editFormFieldInfo(
            this.form_fields,
            instance.formField
          );

          if (result != null) {
            this.form_fields = result.formFileds;
            if (result.groupKey != null && result.groupKey != "") {
              this.form_model[result.groupKey] = [{}];
            }
          }
          modal.destroy();
        }
      }
    );
  }

  //删除Field
  deleteFormFieldConfig(field: KreFormFieldConfig) {
    let result = this.kreTransferService.deleteFormFieldInfo(
      this.form_fields,
      field
    );

    if (result != null) {
      this.form_fields = result.formFileds;
      if (result.groupKey != null && result.groupKey != "") {
        this.form_model[result.groupKey] = [{}];
      }

      this.initTableFieldStatus();
    }
  }
}
